import $ from "jquery";

/**
 * Conditioneel verplicht telefoonnummer (lead form templates v3)
 *
 * Het telefoonveld (`sb_field-conditional-required`) is optioneel, tot de
 * bezoeker bij de contactvoorkeuren (`sb_field-contact-preferences`) Telefoon
 * of WhatsApp aanvinkt. Dan toont het sterretje in het label en zet het veld
 * `aria-required`. De harde afdwinging gebeurt server-side in
 * `lib/wp/gf-lead-form-templates.php`.
 */

const CONSTANTS = {
    FIELD: ".sb_field-conditional-required",
    PREFERENCES: ".sb_field-contact-preferences",
    REQUIRED_VALUES: ["Telefoon", "WhatsApp"],
};

/**
 * Zet de required-state op het telefoonveld op basis van de aangevinkte
 * contactvoorkeuren binnen hetzelfde formulier.
 */
function syncRequiredState($form) {
    const $field = $form.find(CONSTANTS.FIELD);

    if ($field.length === 0) {
        return;
    }

    const isRequired = $form
        .find(`${CONSTANTS.PREFERENCES} input[type="checkbox"]:checked`)
        .toArray()
        .some((input) => CONSTANTS.REQUIRED_VALUES.includes($(input).val()));

    $field.toggleClass("s_required", isRequired);
    $field.find("input").attr("aria-required", isRequired ? "true" : "false");
}

/**
 * Event handler - contactvoorkeur aan-/uitgevinkt
 */
$(document).on("change", `${CONSTANTS.PREFERENCES} input[type="checkbox"]`, function () {
    syncRequiredState($(this).closest("form"));
});

/**
 * Run on page load en na een GF-render (ajax, meerdere stappen)
 */
function init() {
    $(CONSTANTS.FIELD).closest("form").each(function () {
        syncRequiredState($(this));
    });
}

$(document).on("gform_post_render", init);

$(function () {
    init();
});
